// Witch curse choice descriptors. Pure data, no React, no Three.js.
//
// ── Codex (Witch) ──
//   "Tap → Curse target Avatar, choose one:
//      Their spells cost (1) more to cast on their next turn,
//      they lose 2 life, or
//      they have -3 power until your next turn."
//
// The orchestrator owns the actual effect application (ledger writes,
// life loss, stat reverts). This module owns the choice IDs + labels
// so prompts.js renders the right buttons.

export const WITCH_CURSE_CHOICES = Object.freeze([
  { label: 'Spells +1 next turn', value: 'cost'  },
  { label: 'Lose 2 life',         value: 'life'  },
  { label: '-3 power',            value: 'power' },
]);

/** Validation guard: was the choice one of the curse IDs? */
export function isValidWitchCurseChoice(value) {
  return WITCH_CURSE_CHOICES.some((c) => c.value === value);
}
